import { RECEIVE_RELATED_PRODUCTS, REQUEST_PRODUCT_DETAIL } from 'constants/reduxActions';

import { toUSD } from 'helpers/NumberFormats';

const processPrice = p => (p ? toUSD(p) : undefined);

const processPrices = ({ basePrice, salePrice }) => {
  basePrice = processPrice(basePrice);
  salePrice = processPrice(salePrice);
  return {
    basePrice: basePrice || salePrice,
    salePrice: salePrice || basePrice
  };
};

const processStyle = ({ basePrice, salePrice, ...rest }) => {
  const prices = processPrices({ basePrice, salePrice });
  return { ...prices, ...rest };
};

const processDontForgetProduct = relatedProducts => {
  if (!relatedProducts || !relatedProducts.dontForget) {
    return null;
  }
  const { dontForget: { productId, styles, ...rest } } = relatedProducts;
  if (!productId) {
    return null;
  }
  return {
    styles: styles.map(processStyle),
    productId,
    ...rest
  };
};

export default function dontForget(state = { isLoading: true }, { type, data }) {
  switch (type) {
    case RECEIVE_RELATED_PRODUCTS: {
      const product = processDontForgetProduct(data);
      return product ? { isLoading: false, product } : null;
    }
    case REQUEST_PRODUCT_DETAIL: {
      return { isLoading: true };
    }
    default: {
      return state;
    }
  }
}
